import React, { Component } from "react";
import * as Constants from "../../Constants/index"
import axios from "axios";
import swal from "sweetalert";
import LoadingButton from "../common/LoadingButton";
// import SimpleReactValidator from "simple-react-validator";
// import Switch from "react-switch";
// import ReactDragListView from "react-drag-listview";

class CreateProgramMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      mobile: "",
      mVerify: false,
      identityType: "",
      identityNumber: "",
      identityCardBackUrl: "",
      identityCardFrontUrl: "",
      aadharMobile: "",
      aadharNumber: "",
      aadharFrontUrl: "",
      aadharBackUrl: "",
      aadharVerify: 0,
      aadharVerifiedBy: "",
      aadharVerifiedOn: "",
      panNumber: "",
      panFrontUrl: "",
      panVerify: 0,
      panVerifiedBy: "",
      panVerifiedOn: "",
      workAddress1: "",
      workAddress2: "",
      workAddress3: "",
      workCity: "",
      workCityId: null,
      workState: "",
      workStateId: null,
      workDistrict: "",
      workDistrictId: null,
      identityCardBackUrl: "",
      identityCardFrontUrl: "",
      identityNumber: "",
      identityType: "",
      workPincode: "",
      workCountry: "",
      bankAccountNo: "",
      accountType: "",
      ifsc: "",
      beneficiary: "",
      bankName: "",
      holderName: "",
      branchName: "",
      cancelChk: "",
      upiId: "",
      upiIdScreen: "",
      points: 0,
      totalPoints: 0,
      redeemPoints: 0,
      userType: "",
      parentType: "",
      parentId: null,
      roId: null,
      shId: null,
      parents: [],
      status: "",
      firstScan: null,
      lastScan: null,
      lastPayOutDate: null,
      approval: null,
      platform: "",
      appVersion: "",
      registerFrom: "",
      profilePic: "",
      profileVerify: false,
      createDateTime: "",
      sStateId: null,
      sDistrictId: null,
      sCityId: null,
      editMode: false,
      aadharFront: '',
      aadharBack: '',
      cancelChkPhoto: '',
      identityCardFront: '',
      identityCardBack: '',
      panFront: '',
      dob: '',
      prefDistribId1: "",
      prefDistribId2: "",
      submitting: false,
      // Modal state
      modalOpen: false,
      modalImageUrl: "",
      modalImageLabel: "",
    };

  }

  validateForm = () => {

    let errors = {};

    if (!this.state.name) {
      errors.name = 'Name required';
    }
    //  else if (this.state.name.length < 3) {
    // 	errors.name = 'Name must be at least 3 characters';
    // }

    // if (!this.state.dob) {
    // 	errors.dob = 'DOB required';
    // }

    // if (this.state.marital === "married" && !this.state.doa) {
    // 	errors.doa = 'DOA required';
    // }

    // if (!this.state.email) {
    // 	errors.email = 'Email ID required';
    // } else if (!/\S+@\S+\.\S+/.test(this.state.email)) {
    // 	errors.email = 'Invalid email address';
    // }

    // if (!this.state.mobile) {
    // 	errors.mobile = 'Mobile no. required';
    // } else if (this.state.mobile.length !== 10) {
    // 	errors.mobile = 'Mobile no. must be 10 digits';
    // } else if (!/^[6-9]\d{9}$/.test(this.state.mobile)) {
    // 	errors.mobile = 'Invalid mobile no.';
    // }

    // if (!this.state.mobileWhatsApp) {
    // 	errors.mobileWhatsApp = 'Mobile no. required';
    // } else if (this.state.mobileWhatsApp.length !== 10) {
    // 	errors.mobileWhatsApp = 'Mobile no. must be 10 digits';
    // } else if (!/^[6-9]\d{9}$/.test(this.state.mobileWhatsApp)) {
    // 	errors.mobileWhatsApp = 'Invalid whatsapp mobile no.';
    // }

    // if (!this.state.permAddress1) {
    // 	errors.permAddress1 = 'Address required';
    // }
    // if (!this.state.permAddress2) {
    // 	errors.permAddress2 = 'Address required';
    // }
    // if (!this.state.workAddress1) {
    // 	errors.workAddress1 = 'Address required';
    // }
    // if (!this.state.workAddress2) {
    // 	errors.workAddress2 = 'Address required';
    // }
    // if (!this.state.workAddress3) {
    // 	errors.workAddress3 = 'Landmark required';
    // }
    // if (!this.state.workStateId) {
    // 	errors.workStateId = 'State required';
    // }
    // if (!this.state.workdistrictId) {
    // 	errors.workdistrictId = 'District required';
    // }
    // if (!this.state.workCityId) {
    // 	errors.workCityId = 'City required';
    // }
    // if (!this.state.workPincode) {
    // 	errors.workPincode = 'Pincode required';
    // }
    // if (!this.state.photo) {
    // 	errors.photo = 'photo required';
    // }
    // if (!this.state.photo) {
    // 	errors.photo = 'photo required';
    // }
    // if (!this.state.aadharFrontUrl) {
    // 	errors.aadharFrontUrl = 'aadhaar front image required';
    // }
    // if (!this.state.aadharBackUrl) {
    // 	errors.aadharBackUrl = 'aadhaar front image required';
    // }

    // if (!this.state.aadharNumber) {
    // 	errors.aadharNumber = 'aadhaar nunmber required';
    // }
    // if (!this.state.aadharNumber.length !== 12) {
    // 	errors.aadharNumber = 'aadhaar Number is only 12 digits';
    // }
    // // if (!this.state.panFrontUrl) {
    // // 	errors.panFrontUrl = 'Pan front image required';
    // // }
    // if (!this.state.panNumber) {
    // 	errors.panNumber = 'Pan number required';
    // }
    // if (!this.state.panNumber.length !== 10) {
    // 	errors.panNumber = 'Pan number required 10';
    // }
    // if (!this.state.holderName) {
    // 	errors.holderName = 'holder name required';
    // }
    // if (!this.state.accountType) {
    // 	errors.accountType = 'Account type required';
    // }
    // if (!this.state.bankName) {
    // 	errors.bankName = 'bank name required';
    // }
    // if (!this.state.bankAccountNo) {
    // 	errors.bankAccountNo = 'Account number required';
    // }
    // if (!this.state.branchName) {
    // 	errors.branch = 'branch required';
    // }
    // if (!this.state.ifsc) {
    // 	errors.ifsc = 'ifsc required';
    // }
    console.log('error', errors)
    return errors;
  };

  componentDidMount() {
    this.setFieldsFromProps();
    this.SALESRequest();
  }
  SALESRequest = () => {
    const token = localStorage.getItem("token");
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
    let compid = pathSegments[pathSegments.length - 2];
    try {
      let url = "user/manage?sortBy=name&userType=SALES&limit=10000&page=1";
      const resp = axios
        .get(Constants.api + url, {
          headers: {
            Authorization: `Bearer ${token}`, company: compid, program: programid, appVersion: Constants.av,
            platform: Constants.pt
          },

        })
        .then((resp) => {
          if (resp.status == 201 && resp.data.result !== "error") {
            console.log(resp.data.output.results);
            this.setState({
              parents: resp.data.output.results,
            });
          } else {
          }
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      console.error(err);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.resp !== prevProps.resp) {
      this.setFieldsFromProps();
    }
  }

  setFieldsFromProps() {
    const { resp } = this.props;
    if (resp && resp.data.output) {
      const data = resp.data.output;
      this.setState({
        name: data.name,
        email: data.email,
        mobile: data.mobile,
        mVerify: data.mVerify,
        identityType: data.identityType,
        identityNumber: data.identityNumber,
        identityCardFrontUrl: data.identityCardFrontUrl,
        identityCardBackUrl: data.identityCardBackUrl,
        aadharMobile: data.userModelKYC ? data.userModelKYC.aadharMobile : '',
        aadharNumber: data.userModelKYC ? data.userModelKYC.aadharNumber : '',
        aadharFrontUrl: data.userModelKYC ? data.userModelKYC.aadharFrontUrl : '',
        aadharBackUrl: data.userModelKYC ? data.userModelKYC.aadharBackUrl : '',
        aadharVerify: data.userModelKYC ? data.userModelKYC.aadharVerify : '',
        aadharVerifiedBy: data.userModelKYC ? data.userModelKYC.aadharVerifiedBy : '',
        aadharVerifiedOn: data.userModelKYC ? data.userModelKYC.aadharVerifiedOn : '',
        panNumber: data.userModelKYC ? data.userModelKYC.panNumber : '',
        panFrontUrl: data.userModelKYC ? data.userModelKYC.panFrontUrl : '',
        panVerify: data.userModelKYC ? data.userModelKYC.panVerify : '',
        panVerifiedBy: data.userModelKYC ? data.userModelKYC.panVerifiedBy : '',
        panVerifiedOn: data.userModelKYC ? data.userModelKYC.panVerifiedOn : '',
        workAddress1: data.addressWork ? data.addressWork.workAddress1 : '',
        workAddress2: data.addressWork ? data.addressWork.workAddress2 : '',
        workAddress3: data.addressWork ? data.addressWork.workAddress3 : '',
        workCity: data.addressWork ? data.addressWork.workCity : '',
        workCityId: data.addressWork ? data.addressWork.workCityId : '',
        workState: data.addressWork ? data.addressWork.workState : '',
        workStateId: data.addressWork ? data.addressWork.workStateId : '',
        workDistrict: data.addressWork ? data.addressWork.workDistrict : '',
        workDistrictId: data.addressWork ? data.addressWork.workDistrictId : '',
        workPincode: data.addressWork ? data.addressWork.workPincode : '',
        workCountry: data.addressWork ? data.addressWork.workCountry : '',
        bankAccountNo: data.bankDetail ? data.bankDetail.bankAccountNo : '',
        accountType: data.bankDetail ? data.bankDetail.accountType : '',
        ifsc: data.bankDetail ? data.bankDetail.ifsc : '',
        beneficiary: data.bankDetail ? data.bankDetail.beneficiary : '',
        bankName: data.bankDetail ? data.bankDetail.bankName : '',
        holderName: data.bankDetail ? data.bankDetail.holderName : '',
        branchName: data.bankDetail ? data.bankDetail.branchName : '',
        cancelChk: data.bankDetail ? data.bankDetail.cancelChk : '',
        upiId: data.bankDetail ? data.bankDetail.upiId : '',
        upiIdScreen: data.bankDetail ? data.bankDetail.upiIdScreen : '',
        points: data.points,
        totalPoints: data.totalPoints,
        redeemPoints: data.redeemPoints,
        userType: data.userType,
        parentType: data.parentType,
        parentId: data.parentId,
        roId: data.roId,
        shId: data.shId,
        status: data.status,
        firstScan: data.firstScan,
        lastScan: data.lastScan,
        lastPayOutDate: data.lastPayOutDate,
        approval: data.approval,
        platform: data.platform,
        appVersion: data.appVersion,
        registerFrom: data.registerFrom,
        profilePic: data.profilePic,
        profileVerify: data.profileVerify,
        createDateTime: data.createDateTime,
        sStateId: data.sStateId,
        sDistrictId: data.sDistrictId,
        sCityId: data.sCityId,
        dob: data.dob || '',
        firmName: data.firmName || '',
        prefDistribId1: data.prefDistribId1 || '',
        prefDistribId2: data.prefDistribId2 || ''

      });
    }
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  // Modal helpers
  openImageModal = (url, label) => {
    this.setState({ modalOpen: true, modalImageUrl: url, modalImageLabel: label });
  };

  closeImageModal = () => {
    this.setState({ modalOpen: false, modalImageUrl: "", modalImageLabel: "" });
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({ submitting: true });

    const token = localStorage.getItem("token");
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
    let compid = pathSegments[pathSegments.length - 2];
    // Get the last second segment
    const validationErrors = this.validateForm();
    if (Object.keys(validationErrors).length > 0) {
      this.setState({ errors: validationErrors });
      this.setState({ submitting: false });
      return;
    }

    if (this.props.resp) {
      try {

        axios
          .patch(
            Constants.api + "user/manage/" + this.props.resp.data.output.id,
            {
              "name": this.state.name,
              "email": this.state.email,
              "mobile": this.state.mobile,
              "password": this.state.password,
              "status": this.state.status,
              "userModelKYC": {
                "aadharMobile": this.state.aadharMobile,
                "aadharNumber": this.state.aadharNumber,
                "aadharFrontUrl": this.state.aadharFrontUrl,
                "aadharBackUrl": this.state.aadharBackUrl,

                "panNumber": this.state.panNumber,
                "panFrontUrl": this.state.panFrontUrl,
                // "panVerify": this.state.panVerify,
                // "panVerifiedBy": this.state.panVerifiedBy,
                // "panVerifiedOn": this.state.panVerifiedOn
              },
              "addressWork": {
                "workAddress1": this.state.workAddress1,
                "workAddress2": this.state.workAddress2,
                "workAddress3": this.state.workAddress3,
                "workCity": this.state.workCity,
                "workCityId": this.state.workCityId,
                "workState": this.state.workState,
                "workStateId": this.state.workStateId,
                "workDistrict": this.state.workDistrict,
                "workdistrictId": this.state.workDistrictId,
                "workPincode": this.state.workPincode,
                "workCountry": this.state.workCountry
              },
              "bankDetail": {
                "bankAccountNo": this.state.bankAccountNo,
                "accountType": this.state.accountType,
                "ifsc": this.state.ifsc,
                "beneficiary": this.state.beneficiary,
                "bankName": this.state.bankName,
                "holderName": this.state.holderName,
                "branchName": this.state.branchName,
                "cancelChk": this.state.cancelChk,
                "upiId": this.state.upiId,
                "upiIdScreen": this.state.upiIdScreen
              },
              "parentId": this.state.parentId,
              "userType": this.state.userType,
              "identityType": this.state.identityType,
              "identityNumber": this.state.identityNumber,
              "identityCardBackUrl": this.state.identityCardBackUrl,
              "identityCardFrontUrl": this.state.identityCardFrontUrl,
              "getsStateId": this.state.getsStateId,
              "getsDistrictId": this.state.getsDistrictId,
              "getsCityId": this.state.getsCityId,
              "dob": this.state.dob,
              "firmName": this.state.firmName,
              "prefDistribId1": this.state.prefDistribId1,
              "prefDistribId2": this.state.prefDistribId2,
            },
            {
              headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              swal("Member Updated");
              this.onCancelTrigger(0);
            } else if (res.status == 403) {
              // localStorage.clear();
              window.location.href = "/";
            } else {
              // this.setState({alert:res.data.msg});
              swal("Something went wrong!");
            }
          })
          .finally(() => {
            this.setState({ submitting: false });
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
        this.setState({ submitting: false });
      }
    }
    else {
      // Get the last second segment
      try {
        axios
          .post(
            Constants.api + "user/manage",
            {
              "name": this.state.name,
              "email": this.state.email,
              "mobile": this.state.mobile,
              "password": this.state.password,
              "status": this.state.status,
              "userModelKYC": {
                "aadharMobile": this.state.aadharMobile,
                "aadharNumber": this.state.aadharNumber,
                "aadharFrontUrl": this.state.aadharFrontUrl,
                "aadharBackUrl": this.state.aadharBackUrl,

                "panNumber": this.state.panNumber,
                "panFrontUrl": this.state.panFrontUrl,
                // "panVerify": this.state.panVerify,
                // "panVerifiedBy": this.state.panVerifiedBy,
                // "panVerifiedOn": this.state.panVerifiedOn
              },
              "addressWork": {
                "workAddress1": this.state.workAddress1,
                "workAddress2": this.state.workAddress2,
                "workAddress3": this.state.workAddress3,
                "workCity": this.state.workCity,
                "workCityId": this.state.workCityId,
                "workState": this.state.workState,
                "workStateId": this.state.workStateId,
                "workDistrict": this.state.workDistrict,
                "workDistrictId": this.state.workDistrictId,
                "workPincode": this.state.workPincode,
                "workCountry": this.state.workCountry
              },
              "bankDetail": {
                "bankAccountNo": this.state.bankAccountNo,
                "accountType": this.state.accountType,
                "ifsc": this.state.ifsc,
                "beneficiary": this.state.beneficiary,
                "bankName": this.state.bankName,
                "holderName": this.state.holderName,
                "branchName": this.state.branchName,
                "cancelChk": this.state.cancelChk,
                "upiId": this.state.upiId,
                "upiIdScreen": this.state.upiIdScreen
              },
              "parentId": this.state.parentId,
              "userType": this.state.userType,
              "identityType": this.state.identityType,
              "identityNumber": this.state.identityNumber,
              "identityCardBackUrl": this.state.identityCardBackUrl,
              "identityCardFrontUrl": this.state.identityCardFrontUrl,

              "getsStateId": this.state.getsStateId,
              "getsDistrictId": this.state.getsDistrictId,
              "getsCityId": this.state.getsCityId,
              "dob": this.state.dob,
              "firmName": this.state.firmName,
              "prefDistribId1": this.state.prefDistribId1,
              "prefDistribId2": this.state.prefDistribId2,
            },
            {
              headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
            }
          )
          .then((res) => {
            if (res.status === 201) {
              swal("Member Added");
              // this.setState({ create: 0 })
              this.onCancelTrigger(0);
            } else if (res.status == 403) {
              window.location.href = "/";
              localStorage.clear();
            } else {
              // this.setState({alert:res.data.msg});
              swal("Something went wrong!");
            }
          })
          .finally(() => {
            this.setState({ submitting: false });
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
        this.setState({ submitting: false });
      }
    }

  };
  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  onCancelTrigger = (event) => {
    this.props.setViewMode(event);
    event.preventDefault();
  }

  onPancardChange = (event) => {
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (!selectedFile) {
      return;
    }

    // Update the state with the selected file
    this.setState({ panFront: selectedFile }, () => {
      this.updateImage('panFront');
    });
  }
  onAdharfrontChange = (event) => {
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (!selectedFile) {
      return;
    }

    // Update the state with the selected file
    this.setState({ aadharFront: selectedFile }, () => {
      this.updateImage('aadharFront');
    });
  };
  onAdharBackChange = (event) => {
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (!selectedFile) {
      return;
    }

    // Update the state with the selected file
    this.setState({ aadharBack: selectedFile }, () => {
      this.updateImage('aadharBack');
    });
  };
  onCancelChkChange = (event) => {
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (!selectedFile) {
      return;
    }

    // Update the state with the selected file
    this.setState({ cancelChkPhoto: selectedFile }, () => {
      this.updateImage('cancelChkPhoto');
    });
  };
  onidentityCardBackChange = (event) => {
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (!selectedFile) {
      return;
    }

    // Update the state with the selected file
    this.setState({ identityCardBack: selectedFile }, () => {
      this.updateImage('identityCardBack');
    });
  };
  onidentityCardFrontChange = (event) => {
    const selectedFile = event.target.files[0];

    // Check if a file was selected
    if (!selectedFile) {
      return;
    }

    // Update the state with the selected file
    this.setState({ identityCardFront: selectedFile }, () => {
      this.updateImage('identityCardFront');
    });
  };
  updateImage = (type) => {
    let token = localStorage.getItem("token");

    const formData = new FormData();
    if (type == 'aadharFront')
      formData.append("file", this.state.aadharFront);
    if (type == 'aadharBack')
      formData.append("file", this.state.aadharBack);
    if (type == 'identityCardFront')
      formData.append("file", this.state.identityCardFront);
    if (type == 'identityCardBack')
      formData.append("file", this.state.identityCardBack);
    if (type == 'cancelChkPhoto')
      formData.append("file", this.state.cancelChkPhoto);
    formData.append("type", type);
    if (type == "panFront")
      formData.append("file", this.state.panFront);
    formData.append("type", type);


    axios
      .post(
        Constants.api + "uploader/upload",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("langauge"),
            platform: Constants.pt,
            appVersion: Constants.av,
            company: 0, program: 0
          },
        }
      )
      .then((res) => {
        if (res.status == 201) {
          swal(type + " Added");
          if (type == 'aadharFront')
            this.setState({ aadharFrontUrl: res.data.output.url });
          if (type == 'aadharBack')
            this.setState({ aadharBackUrl: res.data.output.url });
          if (type == 'cancelChkPhoto')
            this.setState({ cancelChk: res.data.output.url });
          if (type == 'identityCardFront')
            this.setState({ identityCardFrontUrl: res.data.output.url });

          if (type == 'identityCardBack')
            this.setState({ identityCardBackUrl: res.data.output.url });

          if (type == 'panFront')
            this.setState({ panFrontUrl: res.data.output.url });
        } else if (res.status == 403) {
          localStorage.removeItem("userid");
          window.location.href = "/";
        } else {
          // this.setState({alert:res.data.msg});
          swal("Something went wrong!")
        }
      })
  };
  render() {

    if (this.state.create === 0) {
      window.location.reload()
    }
    const editMode = true;
    let parentId = this.state.parentId;

    return (
      <>
        {/* ── Image Preview Modal ── */}
        {this.state.modalOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.7)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={this.closeImageModal}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                padding: "20px",
                maxWidth: "90vw",
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0 4px 32px rgba(0,0,0,0.4)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <h5 style={{ margin: 0 }}>{this.state.modalImageLabel}</h5>
                <button
                  type="button"
                  onClick={this.closeImageModal}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "22px",
                    cursor: "pointer",
                    lineHeight: 1,
                    color: "#555",
                  }}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>
              <img
                src={this.state.modalImageUrl}
                alt={this.state.modalImageLabel}
                style={{
                  maxWidth: "80vw",
                  maxHeight: "75vh",
                  objectFit: "contain",
                  borderRadius: "4px",
                }}
              />
            </div>
          </div>
        )}

        <main>
          <div className="container">
            <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
              {/* <button style={{border:"none", borderRadius:"10px", height:"30px", backgroundColor:"yellowgreen", color:"black", marginTop:"6px"}} onClick={() => {this.onCancelTrigger(0)}}>Back</button> */}
              <h2>View Member</h2>
            </div>
            <form onSubmit={this.handleFormSubmit}>
              <div class="row">
                <div className="form-group col-sm-3">
                  <label>Name</label>
                  <input
                    className="form-control"
                    name="name"
                    type="text"
                    value={this.state.name}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Mobile</label>
                  <input
                    className="form-control"
                    name="mobile"
                    type="text"
                    value={this.state.mobile}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>DOB</label>
                  <input
                    className="form-control"
                    name="dob"
                    type="text"
                    value={this.state.dob}
                    onChange={(e) => this.setState({ dob: e.target.value })}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Firm Name</label>
                  <input
                    className="form-control"
                    name="firmName"
                    type="text"
                    value={this.state.firmName}
                    onChange={(e) => this.setState({ firmName: e.target.value })}
                  // disabled={true}
                  />
                </div>
                <div class="col-sm-6">
                  <div class="col-sm-6">
                    <div class=" mx-4 input-group-outline my-2">Parent</div>
                    <div class=" mx-4 input-group-outline my-2">
                      <select
                        style={{ width: "200px" }}
                        value={this.state.parentId}
                        name="parentId"
                        class="form-control"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option>Select Parent</option>
                        {this.state.parents.map(function (item, i) {
                          return (
                            <>
                              <option value={item.id}>{item.name}</option>
                            </>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div class=" mx-4 input-group-outline my-2"></div>
                </div>
                <div className="form-group col-sm-3">
                  <label>ID Type</label>
                  <input
                    className="form-control"
                    name="identityType"
                    type="text"
                    value={this.state.identityType}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>ID Number</label>
                  <input
                    className="form-control"
                    name="identityNumber"
                    type="text"
                    value={this.state.identityNumber}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                {/* <div className="form-group col-sm-3">
                  <label>Profile Image</label>
                  <img src={this.state.profilePic} width="150" />
                </div> */}
                <div className="form-group col-sm-3">
                  <label>ID Front Image</label>
                  {this.state.identityCardFrontUrl && (
                    <a href={this.state.identityCardFrontUrl} target="_blank" rel="noopener noreferrer">
                      <img src={this.state.identityCardFrontUrl} width="150" style={{ cursor: 'pointer' }} />
                    </a>
                  )}
                  <input type="file" onChange={this.onidentityCardFrontChange} />
                </div>
                <div className="form-group col-sm-3">
                  <label>ID Back Image</label>
                  <img src={this.state.identityCardBackUrl} width="150" />
                  <input type="file" onChange={this.onidentityCardBackChange} />
                </div>
                <div className="form-group col-sm-3">
                  <label>Aadhar Number</label>
                  <input
                    className="form-control"
                    name="aadharNumber"
                    type="text"
                    value={this.state.aadharNumber}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                {/* <div className="form-group col-sm-3">
                  <label> Mobile Linked with Aadhaar</label>
                  <input
                    className="form-control"
                    name="aadharMobile"
                    type="text"
                    value={this.state.aadharMobile}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div> */}
                <div className="form-group col-sm-3">
                  <label>PAN Number</label>
                  <input
                    className="form-control"
                    name="panNumber"
                    type="text"
                    value={this.state.panNumber}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
              </div>
              <div class="row">
                <div className="form-group col-sm-3">
                  <label>Aadhar Front Image</label>
                  <br />
                  {this.state.aadharFrontUrl && (
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{ backgroundColor: "#58B05C", color: "white" }}
                      onClick={() => this.openImageModal(this.state.aadharFrontUrl, "Aadhar Front Image")}
                    >
                      View
                    </button>
                  )}

                  <input type="file" onChange={this.onAdharfrontChange} />
                </div>

                <div className="form-group col-sm-3">
                  <label>Aadhar Back Image</label>
                  <br />
                  {this.state.aadharBackUrl && (
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{ backgroundColor: "#58B05C", color: "white" }}
                      onClick={() => this.openImageModal(this.state.aadharBackUrl, "Aadhar Back Image")}
                    >
                      View
                    </button>
                  )}

                  <input type="file" onChange={this.onAdharBackChange} />
                </div>
                <div className="form-group col-sm-3">
                  <label>PAN Front Image</label>
                  <br />
                  {this.state.panFrontUrl && (
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{ backgroundColor: "#58B05C", color: "white" }}
                      onClick={() => this.openImageModal(this.state.panFrontUrl, "PAN Front Image")}
                    >
                      View
                    </button>
                  )}

                  <input type="file" onChange={this.onPancardChange} />
                </div>

                <div className="form-group col-sm-3">
                  <label>Email</label>
                  <input
                    className="form-control"
                    name="email"
                    type="email"
                    value={this.state.email}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>

                <div className="form-group col-sm-3">
                  <label> Address 1</label>
                  <input
                    className="form-control"
                    name="workAddress1"
                    type="text"
                    value={this.state.workAddress1}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
              </div>
              <div class="row">
                <div className="form-group col-sm-4">
                  <label> Address 2</label>
                  <input
                    className="form-control"
                    name="workAddress2"
                    type="text"
                    value={this.state.workAddress2}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                {/* <div className="form-group col-sm-4">
                  <label> Address 3</label>
                  <input
                    className="form-control"
                    name="workAddress3"
                    type="text"
                    value={this.state.workAddress3}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div> */}
                <div className="form-group col-sm-4">
                  <label> State</label>
                  <input
                    className="form-control"
                    name="workState"
                    type="text"
                    value={this.state.workState}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label>District</label>
                  <input
                    className="form-control"
                    name="workDistrict"
                    type="text"
                    value={this.state.workDistrict}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label> City</label>
                  <input
                    className="form-control"
                    name="workCity"
                    type="text"
                    value={this.state.workCity}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label> Pincode</label>
                  <input
                    className="form-control"
                    name="workPincode"
                    type="text"
                    value={this.state.workPincode}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (/^\d{0,6}$/.test(value)) {
                        // Allow only numbers up to 6 digits
                        this.setState({ workPincode: value }); // Update state only if valid
                      }
                    }}
                    disabled={!editMode}
                  />
                </div>
              </div>

              <div className="row">
                <div className="form-group col-sm-3">
                  <label>Account Holder Name</label>
                  <input
                    className="form-control"
                    name="holderName"
                    type="text"
                    value={this.state.holderName}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Account Type</label>
                  <input
                    className="form-control"
                    name="accountType"
                    type="text"
                    value={this.state.accountType}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Bank Name</label>
                  <input
                    className="form-control"
                    name="bankName"
                    type="text"
                    value={this.state.bankName}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Bank Account No</label>
                  <input
                    className="form-control"
                    name="bankAccountNo"
                    type="text"
                    value={this.state.bankAccountNo}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>IFSC</label>
                  <input
                    className="form-control"
                    name="ifsc"
                    type="text"
                    value={this.state.ifsc}
                    onChange={this.handleInputChange}
                    disabled={!editMode}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>Cheque</label>
                  <br />
                  {this.state.cancelChk && (
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{ backgroundColor: "#58B05C", color: "white" }}
                      onClick={() => this.openImageModal(this.state.cancelChk, "Cheque")}
                    >
                      View
                    </button>
                  )}
                  <input type="file" onChange={this.onCancelChkChange} />
                </div>

                <div className="form-group col-sm-3">
                  <label>UPI ID</label>
                  <input
                    className="form-control"
                    name="upiId"
                    type="text"
                    value={this.state.upiId}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>pref Distrib ID1</label>
                  <input
                    className="form-control"
                    name="upiId"
                    type="text"
                    value={this.state.prefDistribId1}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="form-group col-sm-3">
                  <label>pref Distrib ID2</label>
                  <input
                    className="form-control"
                    name="upiId"
                    type="text"
                    value={this.state.prefDistribId2}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </div>
                <div class=" mt-4" id="delete">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-sm-0 mb-4">
                      <div class="w-50">
                        {/* <p>Save Country</p> */}
                        {/* <p class="text-sm mb-0">Once you delete your account, there is no going back. Please be certain.</p> */}
                      </div>
                      <div class="w-50 text-end">
                        <button
                          class="btn btn-outline-secondary mb-3 mb-md-0 ms-auto"
                          type="button"
                          name="button"
                          onClick={() => {
                            // this.setState({ create: 0 })
                            this.onCancelTrigger(0);
                          }}
                        >
                          Back
                        </button>
                        <button
                          class="btn btn-outline-secondary mb-3 mb-md-0 ms-auto"
                          type="button"
                          name="button"
                          onClick={() => {
                            // this.setState({ create: 0 })
                            this.onCancelTrigger(0);
                          }}
                        >
                          Cancel
                        </button>
                        {this.state.mVerify == false ? (
                          ""
                        ) : (
                          <LoadingButton
                            class="btn bg-gradient-success mb-0 ms-2"
                            type="submit"
                            name="button"
                            loading={this.state.submitting}
                          >
                            Save{" "}
                          </LoadingButton>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>{" "}
        </main>
      </>
    );
  }

}

export default CreateProgramMembers;